import type { ReactiveMap } from "@solid-primitives/map"
import { Vector3 } from "three"
import type { NeighborWaterCurrentCollection } from "../../../../rx/memo/useNodeNeighborBaseWaterCurrentReactiveMap"
import type { WaterFlowNode } from "../../../../rx/memo/useSharedWaterFlowNodeMapMemo"
import { floor } from "../../../core/util/math/Math"
import { VERTICES_PER_TILE } from "../../consts"
import setTileRelativeWaterCurrentVector3 from "./setTileRelativeWaterCurrentVector3"

export default function setWorldPositionVector3WaterCurrentVector3 (
  nodeNeighborBaseWaterCurrentReactiveMap: ReactiveMap<number, NeighborWaterCurrentCollection>,
  waterFlowNodeMap: Map<number, WaterFlowNode>,
  gridWidth: number,
  worldV3: Vector3,
  outV3 : Vector3): true | void {
  const tileX = floor((worldV3.x / VERTICES_PER_TILE) + 0.5)
  const tileY = floor((worldV3.z / VERTICES_PER_TILE) + 0.5)
  const nodeIndex = tileX + tileY * gridWidth

  const nwcCollection = nodeNeighborBaseWaterCurrentReactiveMap.get(nodeIndex)
  if (!nwcCollection) {
    outV3.set(0, 0, 0)
    return
  }

  const tileRelativeX = (worldV3.x - tileX * VERTICES_PER_TILE) / VERTICES_PER_TILE
  const tileRelativeY = (worldV3.z - tileY * VERTICES_PER_TILE) / VERTICES_PER_TILE

  setTileRelativeWaterCurrentVector3(nwcCollection, tileRelativeX, tileRelativeY, outV3)

  // console.log('nodeIndex', nodeIndex)
  const wfn = waterFlowNodeMap.get(nodeIndex)
  if (wfn) {
    return true
  }
}